/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { LanguagesResponse } from '../../models/languages-response';

export interface CommonControllerGetLanguages$Params {
}

export function commonControllerGetLanguages(http: HttpClient, rootUrl: string, params?: CommonControllerGetLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LanguagesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerGetLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: LanguagesResponse;
      }>;
    })
  );
}

commonControllerGetLanguages.PATH = '/common/languages';
